import React from 'react';
import { asyncComponent } from 'react-async-component';

import { getCmsPageRequest } from '../../CmsActions';

import Loader from '../../../../components/Loader/Loader';

const CmsPageAsync = asyncComponent({
    LoadingComponent: () => <Loader hideContent />,
    resolve: () => import('../view/CmsPage'),
});

CmsPageAsync.need = [(params, store, query) => { return getCmsPageRequest(params.slug, params.lang); }];

export default CmsPageAsync;
